import { render, staticRenderFns } from "./wbdp-accountStatistics-list.vue?vue&type=template&id=a007b19a"
import script from "./wbdp-accountStatistics-list.vue?vue&type=script&lang=js"
export * from "./wbdp-accountStatistics-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports